module.exports = __webpack_public_path__ + "static/cover-switch-e6fe6324d40af4c84b4378bd51e78f19.jpg";